module.exports = __webpack_public_path__ + "static/media/es.f49ea3f0.svg";